var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTriangleVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 37.5,
    r: 36.4583,
    fill: "#1D1D1D",
    stroke: "white",
    strokeWidth: 2.08333
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.0448 21.0171C28.1788 20.5036 27.0835 21.1282 27.0835 22.1355V52.2402C27.0835 53.2475 28.1788 53.8722 29.0448 53.3587L54.4259 38.3063C55.2749 37.8028 55.2749 36.573 54.4259 36.0694L29.0448 21.0171Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangleVideo);
export default __webpack_public_path__ + "static/media/triangle-video.b975d027de495fa5d63aed2c946a3c5c.svg";
export { ForwardRef as ReactComponent };